import createAction from '../../app/services/create-action';

export const SET_LAST_POST_SLUG = 'lastPostSlug/SET';

export const setLastPostSlug = createAction(SET_LAST_POST_SLUG);
